import { render } from "./ActualizarCollegiates4.vue?vue&type=template&id=6807bc78"
import script from "./ActualizarCollegiates4.vue?vue&type=script&lang=js"
export * from "./ActualizarCollegiates4.vue?vue&type=script&lang=js"

import "./ActualizarCollegiates4.vue?vue&type=style&index=0&id=6807bc78&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__